import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import MediationOverview from './Overview';
import MediationNewEntry from './New';
import MediationDetail from './Detail';

const Mediation = (props) => {
  const paths = {
    new: `${props.match.path}/new/:guid`,
    details: `${props.match.path}/detail/:mediGuid/:guid`,
    overview: `${props.match.path}`,
  };

  return (
    <Switch>
      <Route path={paths.new} component={MediationNewEntry} />
      <Route path={paths.details} component={MediationDetail} />
      <Route path={paths.overview} component={MediationOverview} />
    </Switch>
  );
};

export default withRouter(Mediation);
